module.exports = {
  Cities: require('./cities.js'),
  FeaturedCities: require('./featured_cities.js'),
  Countries: require('./countries.js')
}
